import { useTranslation } from "react-i18next";
import { FeedBotAnimatedMark } from "../../../components/brand/FeedBotAnimatedMark.js";

interface AuthEntryHeaderProps {
  title: string;
  subtitle?: string;
  /** Short pill above the title, styled like the login secure-workspace pill. */
  eyebrow?: string;
}

/** Centered FeedBot entry header: mark, optional pill, title, supporting copy. */
export function AuthEntryHeader({ title, subtitle, eyebrow }: AuthEntryHeaderProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <header className="grid justify-items-center text-center">
      <FeedBotAnimatedMark
        label={t("auth.wordmarkLabel")}
        className="mb-4 size-[46px] md:mb-[18px] md:size-[50px]"
      />
      {eyebrow ? (
        <p className="m-0 inline-flex items-center rounded-full bg-[#def5e7] px-[9px] py-[3px] text-[11px] leading-none font-[700] text-[#13764e]">
          {eyebrow}
        </p>
      ) : null}
      <h1 className="m-0 mt-[13px] text-[24px] leading-[1.2] font-[700] tracking-[-0.05em] text-[#12372e] wrap-anywhere md:text-[27px]">
        {title}
      </h1>
      {subtitle ? (
        <p className="m-0 mt-[9px] text-sm leading-normal text-[#82958b] wrap-anywhere">{subtitle}</p>
      ) : null}
    </header>
  );
}
